import {filterMenuItemsForRole, menuItemsFor, type MenuKey} from '@/lib/constants'
import {getAuthUser} from '@/lib/api'

type Props = {activeMenu: MenuKey; activeItemId: string; isLoggedIn: boolean; onNavigate: (path: string) => void}

export function MobileSubNav({activeMenu, activeItemId, isLoggedIn, onNavigate}: Props) {
    if (activeMenu === 'conversation' || activeMenu === 'plugin') return null
    const role = getAuthUser()?.role || ''
    const items = filterMenuItemsForRole(menuItemsFor(activeMenu, isLoggedIn), role).filter((item) => item.id !== 'logout')
    if (items.length < 2) return null
    return <nav className="flex shrink-0 gap-1 overflow-x-auto border-b border-hair bg-white px-3 py-2 md:hidden">
        {items.map((item) => {
            const Icon = item.icon
            const active = item.id === activeItemId
            return <button key={item.id} type="button" onClick={() => onNavigate(item.path)} className={`flex h-9 shrink-0 items-center gap-1.5 rounded-full px-3 text-xs ${active ? 'bg-accent text-white' : 'bg-page text-soft'}`}>
                <Icon size={15}/><span>{item.label}</span>
            </button>
        })}
    </nav>
}
